
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const mainWidget = document.getElementById('yotpo-tabs-main-widget-tab-panel-0');
    if (mainWidget) {
      // Set ARIA attributes correctly
      mainWidget.setAttribute('aria-labelledby', 'yotpo-tab-title');
      mainWidget.setAttribute('role', 'tabpanel');
    } else {
    }
  }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  const img = document.querySelector(".collection-hero__icon");
  if (img && !img.alt) {
    img.alt = "Zildjian Collection Logo";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setInterval(function () {
        const input = document.getElementById("scoreDropdownInput");

        const dropdownList = document.getElementById("scoreDropdownList");

        if (input && dropdownList) {
            input.setAttribute("aria-activedescendant", "yotpo-star-rating-filter-by-all");
        } else if (input) {
            input.removeAttribute("aria-expanded")
            input.removeAttribute("aria-activedescendant"); // Remove to avoid WAVE error
        }
     const logoAnchor = document.getElementsByClassName("sb-logo-anchor")[0];
     const poweredBy = document.getElementsByClassName("powered-by-surebright-text")[0];
    if (logoAnchor && poweredBy && poweredBy.children.length > 1) {
    const appImg = poweredBy.children[1];
      appImg.setAttribute("alt", "app_img");
    }
        const yotpoWidget = document.getElementsByClassName("yotpo-widget-clear")[1];
        if (yotpoWidget) {
          if(yotpoWidget.getAttribute("role") != "region") {
            yotpoWidget.setAttribute("role", "region");
          }
        }

        const rating = document.querySelector('[for="searchInput"]');
        const searching = document.querySelector('[for="scoreDropdownInput"]')
        const searchInput = document.getElementById("searchInput");
        const downTag = document.getElementById("yotpo-tabs-main-widget-tab-panel-0");
      
        if (searching && rating) {
          downTag.removeAttribute("aria-labelledby");
          downTag.removeAttribute("role");
          downTag.removeAttribute("tabindex");
          
          searchInput.setAttribute("readonly", "");
          searchInput.setAttribute("aria-labelledby", "searchingLabel");
          searchInput.setAttribute("aria-autocomplete", "none");
          searchInput.setAttribute("aria-haspopup", "listbox");
          if(searching.id != "scoreDropdownLabel" && rating != "searchingLabel") {
            searching.id = "scoreDropdownLabel"; 
            rating.id = "searchingLabel";
          }
        }

        const location1 = document.getElementById("__dealer_key_0");
        const location2 = document.getElementById("__dealer_key_1");
        if (location1 && location2) {
          if (location1.id == "__dealer_key_0" && location2.id == "__dealer_key_1") {
            location1.removeAttribute("tabindex");
            location1.removeAttribute("role");
            location2.removeAttribute("tabindex");
            location2.removeAttribute("role");
          }
        }

        const yotpo = document.querySelector('.yotpo-widget-clear[aria-labelledby="yotpo-headline-reviews"]')
        if (yotpo) {
          yotpo.removeAttribute("role");
          yotpo.removeAttribute("aria-labelledby");
        }

        const reviewSection = document.querySelector("section.yotpo-widget-clear");
        if (reviewSection) {
          reviewSection.removeAttribute("role");
          reviewSection.removeAttribute("aria-labelledby");
        }

        const footerSection = document.querySelector('[aria-label="footer join bar"]');
        if (footerSection) {
          footerSection.removeAttribute("aria-label")
        }

        const link = document.querySelector('a[data-acsb="sr-trigger"]');
        const asideLink = document.querySelector("#link_aside");
        if (link && !asideLink) {
          const aside = document.createElement("aside");
          aside.id = "link_aside";
          aside.setAttribute("aria-label", "Aside Link");
          document.body.appendChild(aside);
          aside.appendChild(link);
        }
    }, 2000);
});
document.addEventListener("DOMContentLoaded", function () {

  const observer = new MutationObserver(() => {

    const input = document.getElementById("scoreDropdownInput");
    const dropdownList = document.getElementById("scoreDropdownList");

    if (input && dropdownList) {
      input.setAttribute("aria-activedescendant", "yotpo-star-rating-filter-by-all");
    }

    const poweredBy = document.getElementsByClassName("powered-by-surebright-text")[0];
    if (poweredBy && poweredBy.children.length > 1) {
      poweredBy.children[1].setAttribute("alt", "app_img");
    }

    const yotpoWidget = document.getElementsByClassName("yotpo-widget-clear")[1];
    if (yotpoWidget && yotpoWidget.getAttribute("role") !== "region") {
      yotpoWidget.setAttribute("role", "region");
    }

    const downTag = document.getElementById("yotpo-tabs-main-widget-tab-panel-0");
    if (downTag) {
      downTag.removeAttribute("aria-labelledby");
      downTag.removeAttribute("role");
      downTag.removeAttribute("tabindex");
    }

    const reviewSection = document.querySelector("section.yotpo-widget-clear");
    if (reviewSection) {
      reviewSection.removeAttribute("role");
      reviewSection.removeAttribute("aria-labelledby");
    }

    const footerSection = document.querySelector('[aria-label="footer join bar"]');
    if (footerSection) {
      footerSection.removeAttribute("aria-label");
    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const thumbsCarouselList = document.getElementById("thumbsCarousel-list");
  if (thumbsCarouselList) {
    thumbsCarouselList.removeAttribute("aria-orientation");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const detailsElement = document.querySelector('details[id^="Details-"]');

  if (detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");
    if (summaryElement) {
      summaryElement.removeAttribute("role");
    } else {
    }
  } else {
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const dealerButton = document.getElementById("__dealer_key_1");
    if (dealerButton) {
      dealerButton.querySelectorAll("a, button, input, textarea, select").forEach(el => {
        el.setAttribute("tabindex", "-1");
      });
      dealerButton.addEventListener("click", function (event) {
        if (event.target !== dealerButton) {
          event.preventDefault();
          dealerButton.click();
        }
      });
    }
  }, 5000);
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const dealerButton = document.getElementById("__dealer_key_0");

    if (dealerButton) {
      const negativeTabElements = dealerButton.querySelectorAll('[tabindex="-1"]');
      negativeTabElements.forEach(el => {
        el.removeAttribute("tabindex");
      });
    }
  }, 5000);
});
class FaqComponent extends HTMLElement {
  constructor() {
    super();
    this.filters = this.querySelectorAll('.filters .filter');
    this.accordians = this.querySelectorAll('.collapsible-content__grid .accordion');
    this.headinglabel = this.querySelector('.collapsible-content__grid .title .label');
    this.initPages();
  }

  initPages() {
    var activeFilterValue;
    var $this = this;
    var $filters = this.filters;
    this.filters.forEach(filter => {
      if (filter.classList.contains('active')) {
        activeFilterValue = filter.dataset.tag;
      }
      filter.addEventListener('click', function (e) {
        e.preventDefault();
        $filters.forEach(filter => {
          filter.classList.remove('active');
        });
        filter.classList.add('active');
        activeFilterValue = filter.dataset.tag;
        $this.changeaccordians(activeFilterValue);
      })
    });
    this.changeaccordians(activeFilterValue);
  }

  changeaccordians(activeFilterValue) {
    this.headinglabel.innerHTML = activeFilterValue;
    this.accordians.forEach(accordian => {
      accordian.classList.remove('active');
      var tag = accordian.querySelector('h2').dataset.tag;
      if (tag.trim().indexOf(activeFilterValue.trim()) > -1) {
        accordian.classList.add('active');
      }
    });
  }
}
customElements.define('faq-component', FaqComponent);

class AnnouncementComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var slider = new Splide(this.slider, {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      speed: 1000,
      drag: false
    });
    slider.mount();
  }
}

customElements.define('announcement-component', AnnouncementComponent);

class ArticleSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var main_slider = new Splide(this.slider, {
      type: 'loop',
      perPage: 1,
      arrows: false,
      pagination: false,
      breakpoints: {
        990: {
          perPage: 1,
          gap: '10px',
          padding: { right: '5rem' },
        }
      }
    });
    var thumb_slider = new Splide('.article-list', {
      arrows: false,
      pagination: false,
      direction: 'ttb',
      height: '500px',
      wheel: false,
      perPage: 3,
      rewind: true,
      isNavigation: true,
    })
    main_slider.sync(thumb_slider);
    main_slider.mount();
    thumb_slider.mount();
  }
}

customElements.define('article-slider', ArticleSliderComponent);
class EpisodeSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var main_slider = new Splide(this.slider, {
      type: 'loop',
      perPage: 1,
      arrows: true,
      pagination: false
    });
    main_slider.mount();
  }
}

customElements.define('episode-slider', EpisodeSliderComponent);
class SplideComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var desktop_break = false;
    var mobile_break = false;
    if (!this.slider.classList.contains('splide-desktop')) {
      desktop_break = true
    }
    if (!this.slider.classList.contains('splide-mobile')) {
      mobile_break = true
    }
    var main_slider = new Splide(this.slider, {
      type: 'loop',
      perPage: 2,
      perMove: 1,
      gap: 20,
      padding: { right: 200 },
      pagination: false,
      destroy: desktop_break,
      breakpoints: {
        990: {
          perPage: 1,
          destroy: mobile_break,
          gap: '10px',
          padding: { right: '5rem' },
        }
      }
    });
    let bar = main_slider.root.querySelector('.my-carousel-progress-bar');
    main_slider.on('mounted move', function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    });
    main_slider.mount();
  }
}
customElements.define('splide-component', SplideComponent);
class FeaturedCollectionComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var desktop_break = false;
    var mobile_break = false;
    if (!this.slider.classList.contains('splide-desktop')) {
      desktop_break = true
    }
    if (!this.slider.classList.contains('splide-mobile')) {
      mobile_break = true
    }
    var main_slider = new Splide(this.slider, {
      perPage: 4,
      perMove: 1,
      gap: 10,
      pagination: false,
      destroy: desktop_break,
      breakpoints: {
        990: {
          perPage: 2,
          destroy: mobile_break,
          gap: '10px',
          padding: { right: '160px' },
        },
        749: {
          perPage: 1,
          destroy: mobile_break,
          gap: '10px',
          padding: { right: '160px' },
        }
      }
    });
    main_slider.mount();
  }
}
customElements.define('featured-collection-component', FeaturedCollectionComponent);
class articleComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var main_slider = new Splide(this.slider, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: 20,
      pagination: false,
      breakpoints: {
        990: {
          perPage: 2,
          padding: { 'right': '160px' },
          gap: '10px'
        },
        749: {
          perPage: 1,
          padding: { 'right': '160px' },
          gap: '10px'
        }
      }
    });
    main_slider.mount();
  }
}
customElements.define('featured-article-component', articleComponent);
class SplideSlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.splide');
  }
  
  connectedCallback() {
    window.addEventListener('load', () => {
      requestIdleCallback(() => {
        this.initPages();
      });
    });
  }

  initPages() {
    var $this = this;
    var main_slider = new Splide(this.slider, {
      type: 'loop',
      perPage: 1,
      autoplay: true,
      lazyLoad: 'sequential'
    });
    main_slider.on('mounted move', function (newIndex) {
      var slide = $this.slider.querySelectorAll('.slideshow__slide')[newIndex];
      if (slide != undefined) {
        var lazyVideos = slide.querySelectorAll("video.lazy");
        if ("IntersectionObserver" in window) {
          var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
              if (video.isIntersecting) {
                for (var source in video.target.children) {
                  var videoSource = video.target.children[source];
                  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                  }
                }
                video.target.load();
                video.target.classList.remove("lazy");
                lazyVideoObserver.unobserve(video.target);
              }
            });
          });
          lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
          });
        }
      } else {
        var slide = $this.slider.querySelectorAll('.slideshow__slide')[0];
        var lazyVideos = slide.querySelectorAll("video.lazy");
        if ("IntersectionObserver" in window) {
          var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
              if (video.isIntersecting) {
                for (var source in video.target.children) {
                  var videoSource = video.target.children[source];
                  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                  }
                }
                video.target.load();
                video.target.classList.remove("lazy");
                lazyVideoObserver.unobserve(video.target);
              }
            });
          });
          lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
          });
        }
      }
    });
    main_slider.mount();
  }
}

customElements.define('splide-slideshow-component', SplideSlideshowComponent);
document.querySelector('.join-club-btn').addEventListener('click', function (e) {
  e.preventDefault();
  if (window.innerWidth > 749) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UjPLMb']);
  } else {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SaQTrv']);
  }
})

class AudioPlayer extends HTMLElement {
  constructor() {
    super();
    this.global_audios = document.querySelectorAll('audio-player')
    this.audio = this.querySelector('audio');
    this.container = this.querySelector('.container');
    this.audioDuration = this.querySelector('.duration');
    this.playButton = this.querySelector('.play-button');
    this.initPages();
  }
  toggleAudio(event) {
    if (!this.audio.paused) {
      this.audio.pause()
      this.playButton.classList.remove('playing')
    } else {
      this.global_audios.forEach(audio_section => {
        audio_section.querySelector('audio').pause();
        audio_section.querySelector('.play-button').classList.remove('playing');
      });
      this.audio.play()
      this.playButton.classList.add('playing');
      var $this = this;
    }
  }

  initPages() {
    var $this = this;
    this.container.addEventListener('click', function (e) {
      e.preventDefault();
      $this.toggleAudio(e);
    })
    this.audio.addEventListener('ended', function (e) {
      $this.playButton.classList.remove('playing');
    });
  }
}

customElements.define('audio-player', AudioPlayer);

class TabComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }

  initPages() {
    const tabs = this.querySelectorAll('[data-tab-target]')
    const tabContents = this.querySelectorAll('[data-tab-content]')
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = document.querySelector(tab.dataset.tabTarget)
        tabContents.forEach(tabContent => {
          tabContent.classList.remove('active')
        })
        tabs.forEach(tab => {
          tab.classList.remove('active')
        })
        tab.classList.add('active')
        target.classList.add('active')
      })
    })
  }
}

customElements.define('tab-component', TabComponent);

if (document.querySelector('.select-box-menu') != undefined) {
  document.querySelector('.select-box-menu').addEventListener('click', function (e) {
    e.preventDefault();
    this.querySelectorAll('li').forEach(element => {
      element.classList.toggle('show');
    });
  });
  document.querySelectorAll('.select-box-menu li').forEach(element => {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      var $this = e.target;
      if (!this.classList.contains('active') | this.classList.contains('tab')) {
        const href = this.querySelector('a').getAttribute('href');
        location = href;
      }
    });
  });
}


document.querySelectorAll('.mega-menu').forEach(mega_menu => {
  const closeBtn = mega_menu.querySelector('.mega-menu__content .close');
  const menuItem = mega_menu.querySelector('.header__menu-item');

  if (closeBtn && menuItem) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      menuItem.click();
    });
  }
});

const allowedCountries = new Set(['US', 'PR', 'GU', 'VI']);

fetch('/browsing_context_suggestions.json')
  .then(r => r.json())
  .then(data => {
    let countryHandle = data?.detected_values?.country?.handle;

    if (!countryHandle) {
      document.body.classList.add('hide-price');
      return;
    }

    countryHandle = countryHandle.toString().toUpperCase();

    // normalize common Shopify variants
    const map = {
      UNITED_STATES: 'US',
      USA: 'US',
      US: 'US',
      PUERTO_RICO: 'PR',
      GUAM: 'GU',
      'U.S. VIRGIN ISLANDS': 'VI',
      'US VIRGIN ISLANDS': 'VI'
    };

    countryHandle = map[countryHandle] || countryHandle;

    if (allowedCountries.has(countryHandle)) {
      document.body.classList.remove('hide-price');
    } else {
      document.body.classList.add('hide-price');
    }
  })
  .catch(err => {
    console.error('Geo detection failed:', err);
    document.body.classList.add('hide-price');
  });
